import { getMaxStep } from './content';
import type { BootMode } from './types';

export function canAdvanceStep(mode: BootMode, currentStep: number): boolean {
  return currentStep < getMaxStep(mode);
}

export function canGoBackStep(currentStep: number): boolean {
  return currentStep > 1;
}

export function nextStep(mode: BootMode, currentStep: number): number {
  return Math.min(currentStep + 1, getMaxStep(mode));
}

export function prevStep(currentStep: number): number {
  return Math.max(currentStep - 1, 1);
}

export function isTagStep(mode: BootMode, step: number): boolean {
  return mode === 'basic' ? step === 2 : step === 6;
}

export function isRankStep(mode: BootMode, step: number): boolean {
  return mode === 'basic' ? step === 3 : step === 7;
}

export function isTimeboxStep(mode: BootMode, step: number): boolean {
  return mode === 'basic' ? step === 4 : step === 8;
}

export function isFocusStep(mode: BootMode, step: number): boolean {
  return mode === 'basic' ? step === 5 : step === 9;
}

export function isRoleScanStep(mode: BootMode, step: number): boolean {
  return mode === 'advanced' && step === 2;
}

export function isCommsStep(mode: BootMode, step: number): boolean {
  return mode === 'advanced' && step === 3;
}

export function isResearchStep(mode: BootMode, step: number): boolean {
  return mode === 'advanced' && step === 4;
}

export function isHighlightStep(mode: BootMode, step: number): boolean {
  return mode === 'advanced' && step === 5;
}
